import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
import { zIndexes } from '../../const/zIndexes';
import { useTestIdAttribute, } from '../../hooks/useTestIdAttribute';
import { Text } from '../Text/Text';
import { Box } from '../layout/Box';
const StyledTrigger = styled(RadixTooltip.Trigger, {
    padding: 0,
    border: 'none',
    background: 'none',
    lineHeight: 0,
    width: 'fit-content',
});
const StyledContent = styled(RadixTooltip.Content, (p) => ({
    backgroundColor: staticColors.tooltipContentBackground,
    borderRadius: sizes.tooltip.borderRadius,
    maxWidth: p.$enableMaxWidth ? sizes.tooltip.maxWidth : undefined,
    zIndex: zIndexes.tooltip,
    wordBreak: 'break-word',
}));
const StyledArrow = styled(RadixTooltip.Arrow, {
    fill: staticColors.tooltipArrow,
});
export const Tooltip = ({ children, text, tabIndex, testId, asChild = false, delayDuration, content, enableMaxWidth = true, side, }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    return (_jsxs(RadixTooltip.Root, { delayDuration: delayDuration, children: [_jsx(StyledTrigger, { tabIndex: tabIndex, asChild: asChild, type: 'button', children: children }), _jsx(RadixTooltip.Portal, { children: _jsxs(StyledContent, { side: side, sideOffset: 5, $enableMaxWidth: enableMaxWidth, ...testIdAttribute, children: [_jsxs(Box, { spacing: true, children: [text && (_jsx(Text, { variant: 'b3', color: 'white', children: text })), content] }), _jsx(StyledArrow, {})] }) })] }));
};
